import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	cursor: pointer;
`;

export const Text = styled.div`
	color: ${colors.grey8};
`;
export const DangerText = styled.div`
	color: ${colors.red400};
`;
